import(/* webpackMode: "eager" */ "/app/apps/root/src/app/[locale]/root.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/root/src/assets/images/hero-1.avif");
;
import(/* webpackMode: "eager" */ "/app/apps/root/src/assets/images/hero-2.avif");
;
import(/* webpackMode: "eager" */ "/app/apps/root/src/assets/images/hero-3.avif");
;
import(/* webpackMode: "eager" */ "/app/apps/root/src/assets/images/hero-4.avif");
;
import(/* webpackMode: "eager" */ "/app/apps/root/src/assets/images/hero-5.avif");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/root/src/components/BlockSwitch/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/root/src/components/HomeHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/root/src/components/HomeInstallPrompt/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/root/src/components/HomePageDialog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/root/src/components/MarketingModals/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/experiments/src/components/Flags/Flags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/layout/src/components/FlashMessages/FlashMessages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/layout/src/components/Page.tsx");
